import { useEffect, useState } from "react";
import EstimationHeader from "./EstimationHeader"
import Resource from "./Resource"
import Sprint from "./Sprint"
import "./estimation-engine.css"
import Object from "./Object";
import Tools from "./Tools";
import { getMasterList, getRateMaster } from "../../services/adminServices";
import { useParams } from "react-router-dom";
import { showLoader } from "../../utils/showloader";
import { getEstimationData, saveEstimationData } from "../../services/estimationServices";
import { getRateForSelectedSkill } from "../../utils/masterHelper";
import { message } from "antd";
import { useTranslation } from 'react-i18next';

const sprintSettings = {timeline: "Week", duration: 15};

const EstimationEngine = () => {
    const { t } = useTranslation();
    const [sprintDetail, setSprintDetail] = useState({...sprintSettings})
    const [estimationData, setEstimationData] = useState({"sprints": [], "resources": {resources: []}, "objects": [], "tools": []})
    const [rateMaster, setRateMaster] = useState([])
    const [originalData, setOriginalData] = useState({})
    const [masterList, setMasterList] = useState([])
    const { spaceId } = useParams();

    const fetchRateMasterData = async () => {
        showLoader(true)
        let requireMasterData = await getRateMaster();
        showLoader(false)
        if (requireMasterData.data) {
            // let reqData = convertKeyToLabel(requireMasterData.data)
            setRateMaster(requireMasterData.data)
        }
    }

    const getData = async () => {
        // showLoader(true)
        let response = await getMasterList();
        // showLoader(false)
        if (response.data) {
            setMasterList(response.data)
        } else {
            setMasterList([])
        }
    }

    const fetchEstimationData = async () => {
        showLoader(true)
        let reqData = await getEstimationData(spaceId);
        showLoader(false)
        setOriginalData(reqData)
        let formattedData = { sprints: reqData.sprints?.[0]?.["sprints"], objects: reqData.objects?.[0]?.["objects"], resources: reqData?.resources || {}, tools: reqData?.tools?.[0]?.["tools"] || []}
        // let estimation = {sprints: reqData.sprints, objects: reqData.objects, tools: reqData?.tools || [], resources: reqData?.resources || []}
        setEstimationData(formattedData)
    }

    useEffect(() => {
        fetchEstimationData();
        getData()
        fetchRateMasterData();
    },[])

    const addSprintDuration = (count=1) => {
        setSprintDetail({...sprintDetail, duration: Number(sprintDetail.duration) + count})
    }

    const updateEstimation = (key, values) => {
        setEstimationData({...estimationData, [key]: values})
    }

    const saveEstimation = async () => {
        let postData = {...estimationData, timeline: "Week", sprints: estimationData.sprints || [], objects: estimationData.objects || [], tools: estimationData.tools || []}
        if(estimationData.objects?.length > 0) {
            let reqObjects = estimationData.objects;
            let masterObjects = masterList.find(data => data.dataName === "Object")?.data;
            let objects = reqObjects.map(obj => {
                let curObj = masterObjects?.find(object => object["Object"] === obj["Object"] && obj["Complexity"] === object["Complexity"])
                let reqEffort = [], objCount = obj.count
                return {...obj, Rate: Number(curObj?.["Rate"])}
            })
            postData["objects"] = objects
            
        }
        if(estimationData.sprints){
            let reqSprints = estimationData.sprints.map(sprint => {
                if(sprint.subLevels?.length > 0) {
                    sprint.subLevels = sprint.subLevels.map(subLevel => {
                        return {...subLevel, start: String(subLevel.start), end: String(subLevel.end)}
                    })
                }
                return {...sprint, start: String(sprint.start), end: String(sprint.end)}
            })
            postData.sprints = reqSprints
        }
        if(estimationData.tools?.length > 0) {
            let reqTools = estimationData.tools;
            let masterTools = masterList.find(data => data.dataName === "Tool")?.data;
            let postTools = reqTools.map(obj => {
                let curTool = masterTools?.find(object => object["Tool"] === obj["Tool"])
                
                return {...obj, Rate: Number(curTool?.["Rate"]), "BillingCycle": curTool?.["Billing Cycle"] || curTool?.BillingCycle, UoM: curTool["UoM"], count: obj.count}
            })
            // postData["tools"] = {timeline: "Week", data: postTools}
            postData["tools"] = postTools

        }
        if(estimationData.resources?.resources?.length > 0) {
            let reqResourceData = [], finalResources = [...estimationData.resources?.resources]
            finalResources.forEach(resource => {
                let resourceObj = {...resource}, teams = [];
                if(resourceObj?.teams){
                    let currentTeam = resourceObj.teams
                    for(const key in currentTeam){
                        let reqTeams = []
                        let teams = currentTeam[key] 
                        teams.forEach(teamObj => {
                            let reqTeamObj = {}
                            for(const teamKey in teamObj) {
                                let reqKey = teamKey.replaceAll(" ", "")
                                reqTeamObj[reqKey] = teamObj[teamKey]
                            }
                            let currentSkillRate = {}
                            if(!teamObj.rate) {
                                currentSkillRate = getRateForSelectedSkill(resource.deliveryUnit, {...teamObj, "Team": key}, rateMaster)
                            } else {
                                currentSkillRate = teamObj.rate
                            }
                            let reqCount = {...teamObj.count}
                            for(const countKey in teamObj.count) {
                                reqCount[countKey] = teamObj.count[countKey]
                                delete reqCount[countKey]["cost"]
                            }
                            if(reqTeamObj.calculatedCosts) {
                                delete reqTeamObj.calculatedCosts
                            }
                            reqTeams.push({"Team": key, ...reqTeamObj, count: reqCount, rate: currentSkillRate})
                        })
                        reqResourceData.push({uuid: resource.uuid, deliveryUnit: resource.deliveryUnit, teams: reqTeams})
                    }

                }

            })
            postData["resources"] = reqResourceData
        }
        // return
        showLoader(true)
        let saveResponse = await saveEstimationData(postData, spaceId);
        if(saveResponse){
            message.success(t('Estimation updated successfully'))
            await fetchEstimationData();
        }
        showLoader(false)

    }
    return (
        <>
            <EstimationHeader saveEstimation={saveEstimation} />
            <div className="estimation-container">
                <Sprint sprintDetail={sprintDetail} addSprintDuration={addSprintDuration} estimationData={estimationData} updateEstimation={updateEstimation} />
                <div className="separator"></div>
                <Resource sprintDetail={sprintDetail} masterList={masterList} estimationData={estimationData} updateEstimation={updateEstimation} />
                <div className="separator"></div>   
                <Object sprintDetail={sprintDetail} masterList={masterList} estimationData={estimationData} updateEstimation={updateEstimation} />
                <div className="separator"></div>   
                <Tools sprintDetail={sprintDetail} masterList={masterList} estimationData={estimationData} updateEstimation={updateEstimation} />
            </div>
        </>
    )
}

export default EstimationEngine